// removed by extract-text-webpack-plugin
module.exports = {"wrap":"rec_b_3boacO9","wrap_content_item":"rec_b_2tntiS9","hover_img":"rec_b__HVB5dh"};


//////////////////
// WEBPACK FOOTER
// ./src/component/rec/rec_b.css
// module id = 844
// module chunks = 0